import { render, staticRenderFns } from "./listPageHeader.vue?vue&type=template&id=06d54964&scoped=true"
import script from "./listPageHeader.vue?vue&type=script&lang=js"
export * from "./listPageHeader.vue?vue&type=script&lang=js"
import style0 from "./listPageHeader.vue?vue&type=style&index=0&id=06d54964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d54964",
  null
  
)

export default component.exports